import { render } from "./ButtonApproveModal.vue?vue&type=template&id=c90490be"
import script from "./ButtonApproveModal.vue?vue&type=script&lang=js"
export * from "./ButtonApproveModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__